import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { GetGiftDTO } from "./models";

export const GetGiftApi = async (dto: GetGiftDTO) => {
  const { data } = await api.post(
    API_ROUTES.BONUS,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};
